module.exports = __webpack_public_path__ + "static/img/clientConceptPic1.0d443ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/clientConceptPic1.jpg
// module id = yeXl
// module chunks = 0